<template>
    <div>
        <form-row title="Ability to extend Entitlement Period?">
            <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
                <input-radio-boolean
                    name="entitlement_can_extend"
                    v-model="entitlement_can_extend"
                    true="Yes"
                    false="No"
                    :read_only="read_only"
                    @input="updateCanExtend"
                />

                <div v-if="entitlement_can_extend" class="mt-4 sm:mt-0 pl-8 flex flex-1 items-center">
                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="entitlement_extend_days"
                            v-model="entitlement_extend_days"
                            placeholder="Days"
                            :read_only="read_only"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug px-4">
                        {{ $t('days, to') }}
                    </span>

                    <input-date
                        name="entitlement_extended_date"
                        :value="entitlement_extended_date"
                        :read_only="true"
                    />
                </div>
            </div>
        </form-row>

        <div v-if="entitlement_can_extend">
            <entitlement-period-extend-dates
                :commercial="commercial"
                :read_only="read_only"
            />

            <entitlement-period-extend-additional-money
                v-model="entitlement_additional_money_amount"
                :commercial="commercial"
                :read_only="read_only"
            />

            <entitlement-period-extend-toward-purchase
                :commercial="commercial"
                :additional_money_amount="entitlement_additional_money_amount"
                :read_only="read_only"
            />

            <entitlement-period-extend-refundable
                :commercial="commercial"
                :additional_money_amount="entitlement_additional_money_amount"
                :read_only="read_only"
            />
        </div>
    </div>
</template>

<script>
import DateFunctions from '../../../../mixins/date-functions.js';
import EntitlementPeriodExtendDates from './entitlement-period-extend-dates.vue';
import EntitlementPeriodExtendAdditionalMoney from './entitlement-period-extend-additional-money.vue';
import EntitlementPeriodExtendTowardPurchase from './entitlement-period-extend-toward-purchase.vue';
import EntitlementPeriodExtendRefundable from './entitlement-period-extend-refundable.vue';

export default {
    mixins: [
        DateFunctions,
    ],

    components: {
        EntitlementPeriodExtendDates,
        EntitlementPeriodExtendAdditionalMoney,
        EntitlementPeriodExtendTowardPurchase,
        EntitlementPeriodExtendRefundable,
    },

    props: {
        commercial: {},
        entitlement_date: {},
        value: {},
        read_only: { default: false },
    },

    data() {
        return {
            entitlement_can_extend: this.commercial.entitlement_can_extend,
            entitlement_additional_money_amount: this.commercial.entitlement_additional_money_amount,
        }
    },

    computed: {
        entitlement_extend_days: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        entitlement_extended_date() {
            if (this.isValidDate(this.entitlement_date) && this.entitlement_extend_days) {
                return dayjs(this.entitlement_date.slice(0, 10))
                    .add({ day: this.entitlement_extend_days })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        updateCanExtend() {
            if (! this.entitlement_can_extend) {
                this.entitlement_extend_days = null;
            }
        },
    },
}
</script>
